module.exports = __webpack_public_path__ + "img/link-blue-icon.106ca45c.svg";